import {truncate, unescape} from 'lodash';

export default (string, options = {}) => truncate(unescape(string), options);
